import {UIpagination} from './UIpagination'
(function() {
    const $uips = document.querySelectorAll('.ui-pagination')
    $uips.forEach($uip => new UIpagination.Pagination($uip))
})()